import { BASE_URL } from "../../../Constant";
export const API_COMPETITION_WEBSITE_SAVE : string = BASE_URL + '/api/competitionWebsite';
export const API_LOAD_ALL_COMPETITION_WEBSITES_FOR_BUSINESS_ID : string = BASE_URL + '/api/competitionWebsite/businessId';
export const API_LOAD_BY_COMPETITION_WEBSITE_ID : string = BASE_URL + '/api/competitionWebsite';